import {ColumnsType} from "antd/lib/table";
import {ProductPriceDto} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";

export default function ProductPricesList(props: CrudTableWrapperProps<ProductPriceDto>) {
    const columns: ColumnsType<ProductPriceDto> = [
        {
            key: nameof<ProductPriceDto>("unitValue"),
            dataIndex: nameof<ProductPriceDto>("unitValue"),
            title: "Wartość (zł)"
        },
        {
            key: nameof<ProductPriceDto>("unitStock"),
            dataIndex: nameof<ProductPriceDto>("unitStock"),
            title: "Stan magazynowy"
        },
        {
            key: nameof<ProductPriceDto>("unit"),
            dataIndex: nameof<ProductPriceDto>("unit"),
            title: "Jednostka miary"
        },
        {
            key: nameof<ProductPriceDto>("taxRate"),
            dataIndex: nameof<ProductPriceDto>("taxRate"),
            title: "Stawka podatku"
        },
    ];

    return <>
        <CrudTable
            data={props.data}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            columns={columns}
            cancelButtonTitle={"Anuluj"}
            editButtonTitle={"Edytuj"}
            deleteButtonTitle={"Usuń"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć wybraną cenę?"}
            addButtonTitle={"+ Dodaj nową cenę"}
        />
    </>
}
